
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[department]",
      function () {
        return require("private-next-pages/products/[department]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/[department]"])
      });
    }
  